import { Box, Divider, useColorScheme } from "@mui/joy";
import { Plus } from "lucide-react";

import { InspectionTaskComponent } from "../../../../components/Inspection/components";
import { WorkEstimationTaskComponent } from "../../../../components/WorkEstimation/components";
import { ContractTaskComponent } from "../../../../components/ContractSigning/components";
import { MaterialOrderingTaskComponent } from "../../../../components/MaterialOrdering/components";
import { JobExecutionTaskComponent } from "../../../../components/JobExecution/components";
import { FinalSettlementTaskComponent } from "../../../../components/FinalSettlement/components";

import { Button, ProgressStepper } from "../../../../shared";

import { useTaskHandler } from "./hooks";
import { BuildingPermitTaskComponent } from "../../../BuildingPermit/component";

export default function ListTask() {
    const {
        currentStep,
        taskList,
        handleClickOnProgressBar,
        activeTask,
        measurements,
        setMeasurements,
        attributes,
        setAttributes,
        actionProgress,
        handleOnEstimateCompletion,
        handleOnInspectionCompletion,
        handleOnContractSigningCompletion,
        handleJobExecutionCompletion,
        handleFinalSettlementTaskCompletion,
        handleProjectStatusUpdate,
    } = useTaskHandler();

    const { mode } = useColorScheme();

    return (
        <Box mt={-2} mx={0}>
            <Box
                sx={{
                    position: "sticky",
                    top: "48px",
                    width: "100%",
                    zIndex: 1002,
                    bgcolor: mode === "light" ? "white" : "#1e1e1e",
                    pt: 2,
                }}
            >
                <Box mb={2} mt={1} display={"flex"} alignItems={"center"} justifyContent={"space-between"} gap={2}>
                    <ProgressStepper currentStep={currentStep} steps={taskList} onClick={handleClickOnProgressBar} />
                    <Divider orientation="vertical" />
                    <Button
                        variant={"outlined"}
                        color={"neutral"}
                        startDecorator={<Plus size={14} />}
                        sx={{ flexShrink: 0 }}
                    >
                        Add task
                    </Button>
                </Box>
                <Divider inset="context" sx={{ ml: -2, mr: -2 }} />
            </Box>
            <Box display={"flex"} gap={2} flexDirection={"column"}>
                {activeTask?.Name === "Initial Inspection" && (
                    <InspectionTaskComponent
                        activeTask={activeTask}
                        measurements={measurements}
                        setMeasurements={setMeasurements}
                        attributes={attributes}
                        setAttributes={setAttributes}
                        onComplete={handleOnInspectionCompletion}
                    />
                )}

                {activeTask?.Name === "Estimate/Contract" && (
                    <WorkEstimationTaskComponent
                        activeTask={activeTask}
                        measurements={measurements}
                        onComplete={handleOnEstimateCompletion}
                        actionProgress={actionProgress}
                    />
                )}
                {activeTask?.Name === "Contract Signing" && (
                    <ContractTaskComponent
                        activeTask={activeTask}
                        measurements={measurements}
                        onComplete={handleOnContractSigningCompletion}
                        actionProgress={actionProgress}
                    />
                )}
                {activeTask?.Name === "Material Ordering" && (
                    <MaterialOrderingTaskComponent
                        activeTask={activeTask}
                        onComplete={handleOnInspectionCompletion}
                        actionProgress={actionProgress}
                    />
                )}
                {activeTask?.Name === "Building Permit" && (
                    <BuildingPermitTaskComponent
                        activeTask={activeTask}
                        onComplete={handleOnInspectionCompletion}
                        actionProgress={actionProgress}
                    />
                )}
                {activeTask?.Name === "Job Execution" && (
                    <JobExecutionTaskComponent
                        activeTask={activeTask}
                        onComplete={handleJobExecutionCompletion}
                        actionProgress={actionProgress}
                    />
                )}
                {activeTask?.Name === "Final Settlement" && (
                    <FinalSettlementTaskComponent
                        activeTask={activeTask}
                        onTaskClose={handleFinalSettlementTaskCompletion}
                        onProjectClose={handleProjectStatusUpdate}
                        actionProgress={actionProgress}
                    />
                )}
            </Box>
        </Box>
    );
}
